import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { CategoryDataResponse, templateApi } from '@/api/templateApi'
import { BaseWidgetTemplate, TemplatesCategoryData } from '@/types/templates'


class TemplatesCategoryCachedService extends BaseCachedDataService<Partial<CategoryDataResponse>> {
    private readonly maxRetries = 4
    private readonly retryDelay = 1000

    constructor () {
        super({
            CategoryList: [],
            TemplateList: []
        })
    }

    async loadData () {
        let retries = 0
        let lastError: Error | null = null

        while (retries < this.maxRetries) {
            try {
                const { CategoryList = [], TemplateList = [] } = await templateApi.getTemplatesAndCategories() as {
            CategoryList: Array<TemplatesCategoryData>
            TemplateList: Array<BaseWidgetTemplate>
        }
                return this.data = {
                    CategoryList,
                    TemplateList
                }
            } catch (error) {
                lastError = error as Error
                retries++
                if (retries === this.maxRetries) {
                    console.error(`Failed to fetch templates after ${this.maxRetries} attempts:`, lastError)
                    throw lastError
                }

                await new Promise(resolve => setTimeout(resolve, this.retryDelay))
            }
        }

        // This line should never be reached due to the throw in the catch block
        return this.data
    }
}

export default new TemplatesCategoryCachedService()
